import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import {
  Button, Container, Form, Loader
} from 'semantic-ui-react';

import ReactModalDraggable from 'react-modal-resizable-draggable';
import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';
import { ASSIGNMENT_STATUS, ASSIGNMENT_TYPE } from '../../managers/AssignmentManager';
import { CONTENT_MODE } from '../../managers/ContentManager';
import StudentHelperService from '../../services/StudentHelperService';

import '../../css/PresentAssignmentModal.less';

export default @inject(
  'accommodationsManager', 'assignmentManager',
  'classroomManager', 'contentManager', 'courseManager', 'groupsManager',
  'reportIdentityManager', 'reportStandardsClassroomDetailStudentsManager', 'userManager')
@observer
class PresentAssignmentModal extends Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this.ModalBannerDraggable = SatCoreComponent('ModalBannerDraggable');
    this.SCRadio = SatCoreComponent('SCRadio');

    this.modalRef = React.createRef();
  }

  getInitialState() {
    const {
      assignType,
      assignmentManager,
      isReassign
    } = this.props;

    const now = new Date();
    const assignmentType = assignType || ASSIGNMENT_TYPE.CLASSROOM_USER;

    // Get start and end dates. End date may be modified by contentDuration or based on dueDate depending on which is present if any.

    return {
      addingAssignment: false,
      assignmentType,
      isReassign: isReassign || false,
      presentationMode: 'new',
      selectedAssignmentId: null
    };
  }

  async componentDidMount() {
    const { courseElement } = this.props;

    if (this.modalRef && this.modalRef.current) {
      this.modalRef.current.focus();
    }

    const status = [ASSIGNMENT_STATUS.LOCKED, ASSIGNMENT_STATUS.READY, ASSIGNMENT_STATUS.STARTED];
    await StudentHelperService.fetchPresentationAssignments({ courseResourceElementId: courseElement.elementId, status });
  }

  // eslint-disable-next-line react/sort-comp
  closePresentAssignmentModal = ({ shouldTriggerScrollRestore = true } = {}) => {
    const { closePresentAssignment, handleScrollRestorePendingIfApplicable } = this.props;

    this.setState(this.getInitialState());
    closePresentAssignment();
    if (shouldTriggerScrollRestore) {
      handleScrollRestorePendingIfApplicable?.();
    }
  };

  submitPresentAssignment = async () => {
    try {
      const { handlePresent, fromSatelliteTab, prepareSatelliteLaunchWindow } = this.props;
      const { presentationMode, addingAssignment, selectedAssignmentId } = this.state;

      if (addingAssignment) {
        return;
      }

      if (fromSatelliteTab) {
        prepareSatelliteLaunchWindow?.();
      }

      if (presentationMode === 'new') {
        this.setState({ addingAssignment: true });
        const {
          assignmentManager, classroomManager, courseManager, courseElement
        } = this.props;

        const { elementId, contentItemId } = courseElement;
        const courseContentItemId = courseElement.courseContentItemId || courseManager.currentCourseId;

        await assignmentManager.presentCreateAssignment(
          contentItemId,
          elementId,
          classroomManager.currentClassroomId,
          courseContentItemId);

        const lastAddedAssignment = assignmentManager.getLastAddedAssignment();
        handlePresent({ assignment: lastAddedAssignment, contentMode: CONTENT_MODE.TEACHER_PRESENT });
      } else if (presentationMode === 'load' && selectedAssignmentId) {
        this.setState({ addingAssignment: true });
        const { assignmentManager } = this.props;
        const assignment = assignmentManager.presentationAssignments.get(selectedAssignmentId);
        if (assignment) {
          // Handle loading the selected presentation
          handlePresent({ assignment, contentMode: CONTENT_MODE.TEACHER_PRESENT });
        }
      }
      this.setState({ addingAssignment: false });
      this.closePresentAssignmentModal({ shouldTriggerScrollRestore: false });
    } catch (error) {
      console.error(error);
      if (error instanceof Error) {
        throw error;
      } else {
        throw new TypeError(typeof error === 'string' ? error : t('submitPresentAssignmentError', 'Error submitting presentation'));
      }
    }
  };

  handlePresentationModeChange = (value) => {
    const { assignmentManager } = this.props;
    const presentationAssignments = Array.from(assignmentManager.presentationAssignments.values());
    
    if (value === 'load' && presentationAssignments.length > 0) {
      this.setState({ 
        presentationMode: value,
        selectedAssignmentId: presentationAssignments[0].id 
      });
    } else {
      this.setState({ presentationMode: value });
    }
  }

  renderSelectionContent = () => {
    const { t, assignmentManager } = this.props;
    const { SCRadio } = this;
    const { presentationMode, selectedAssignmentId } = this.state;

    const presentationAssignments = Array.from(assignmentManager.presentationAssignments.values());

    return (
      <div className='content-column'>
        <div className='presentation-description'>
          {t('presentationDescription', 'Presenting allows you to record answers to questions and utilize all the tools in a lesson as if you were the student. When you choose to present you can either create a new presentation or access one you already have in progress. All of your interactions are saved in the Gradebook.')}
        </div>
        <div className='presentation-options'>
          <SCRadio
            checked={presentationMode === 'new'}
            label={t('createNewPresentation', 'Create new presentation')}
            name='presentationOption'
            onChange={() => this.handlePresentationModeChange('new')}
            value='new'
          />
          <SCRadio
            checked={presentationMode === 'load'}
            disabled={presentationAssignments.length === 0}
            label={t('loadPreviousPresentation', 'Load previously started presentation:')}
            name='presentationOption'
            onChange={() => this.handlePresentationModeChange('load')}
            value='load'
          />
          {presentationMode === 'load' && (
            <div className='presentation-assignments-list'>
              {presentationAssignments.map((assignment) => (
                <SCRadio
                  key={assignment.id}
                  checked={selectedAssignmentId === assignment.id}
                  label={`Start Date: ${new Date(assignment.timezoneStartDate).toLocaleDateString()} ${assignment.timezoneStartTime}`}
                  name='presentationAssignment'
                  onChange={() => this.setState({ selectedAssignmentId: assignment.id })}
                  value={assignment.id}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const {
      presentAssignmentOpen,
      assignmentManager,
      t
    } = this.props;

    const { addingAssignment } = this.state;

    const { ModalBannerDraggable } = this;

    const assignmentModalClassNames = 'PresentAssignmentModal';
    const className = 'assignmentModal';

    return (
      <div className={assignmentModalClassNames}>
        <ReactModalDraggable
          className={className}
          closeOnDimmerClick={false}
          closeOnEscape={true}
          disableKeystroke={true}
          isOpen={presentAssignmentOpen}
          onRequestClose={(event) => {
            const isOverlay = event?.target?.className === 'flexible-modal-mask';
            if (!isOverlay) {
              this.closePresentAssignmentModal();
            }
          }}>
          <div ref={this.modalRef} className='modalBody' tabIndex={-1}>
            <ModalBannerDraggable
              label={t('presentationMode', 'Presentation Mode')}
              onClose={this.closePresentAssignmentModal} />
            <div className='content'>
              <Form>
                <Container className='assignment-wrapper-modal'>
                  <Loader active={addingAssignment} />
                  {this.renderSelectionContent()}
                </Container>
              </Form>
            </div>
            <div className='actions'>
              <Button
                basic
                className='cancelButton'
                disabled={addingAssignment}
                onClick={this.closePresentAssignmentModal}
                primary>
                {t('cancel', 'Cancel')}
              </Button>

              <Button
                className='ui primary button saveButton'
                loading={addingAssignment}
                onClick={() => {
                  this.submitPresentAssignment().catch((error) => {
                    error = error instanceof Error && error?.message ?
                      error.message : t('submitPresentAssignmentError', 'Error submitting presentation');
                    console.log('************* error *************', error);
                  });
                }}
                type='button'>
                {t('open', 'Open')}
              </Button>

            </div>
          </div>
        </ReactModalDraggable>
      </div>
    );
  }
}

SatCoreRegister('PresentAssignmentModal', PresentAssignmentModal);
